<template>
  <div class="essenza-combo-picker" ref="comboPickerWrapper">
    
  </div>
</template>

<script>
</script>
<style lang="scss" scoped>
.essenza-combo-picker {
  display: flex;
  
}
</style>